import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom'

import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { checkAccess } from '../../actions/WelcomeActions';
import axios from 'axios';

import { Row, Col} from 'reactstrap';
import { showMessage } from '../../actions/FlashMessageActions';
import { FormattedMessage } from 'react-intl';
import { console_log,parseQueryString, getSubdomain, getUid } from '../../utils/helper';
import { config } from '../../constants/domainConfig';
import Loader from './../loader/loader'
import { messages } from '../../constants/messages';



class RegisterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
            errorMessage: '',
            domain: window.location.host,
            msisdnNotFound: false,
            reason: '',
            username: '',
            password: '',
            cpassword: '',
            submitted: false,
            loading: false,
            error: {
                email:false,
                password:false,
                confirmPassword:false
            },
            isDisabled:false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    isValid(){
        let { username, password, cpassword,error} = this.state;
        if(username ==""){
            error.email=true;
           this.setState({
               error:error
           })
        }else{
            error.email=false;
           this.setState({
               error:error
           })
        }
        if(password ==""){
            error.password=true;
           this.setState({
               error:error
           })
        }else{
            error.password=false;
            this.setState({
                error:error
            })
        }
        if(cpassword ==""){
            error.cpassword=true;
           this.setState({
               error:error
           })
        }else{
            error.cpassword=false;
            this.setState({
                error:error
            })
        }
        if(error.email || error.password || error.cpassword){
            return false
        }
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(String(username).toLowerCase())){
            this.props.showMessage({
                message: messages[config.lang].emailFormate,
                type: false
            });
            return false
        }
        if (password != cpassword) {
            this.props.showMessage({
                message: messages[config.lang].passwordNotMatch,
                type: false
            });
            return false;
        }
        return true
    }

    handleSubmit(e) {
        e.preventDefault();
        const { username, password, cpassword, returnUrl } = this.state;   
        let uidData= JSON.parse(sessionStorage.getItem('uid'));
        if(this.isValid()) {
            this.setState({
                loading:true
            })
            this.registerUser({
                username: username,
                password: password,
                uid : uidData.uid
            });
        }
    }

    registerUser(input) {
        axios.post(vars.BASE_API_URL + `/register`,{ 
                email: input.username,
                password: input.password,
                uid: input.uid,
                timeZone : "GMT+5:30"
            })
            .then((response) => {
                console.log("response",response)
                this.setState({ loading:false });
                if (response.data.success) {
                    this.props.showMessage({
                        message: messages[config.lang].registerSuccess,
                        type: true
                    });
                    this.setState({ submitted: true});
                }else{
                    let message="";
                    if(response.data.data && response.data.data.message){
                        message=response.data.data.message
                    }else{
                        message=response.data.data
                    }
                    this.props.showMessage({
                        message: message,
                        type: false
                    });
                   
                }
               
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading:false });
                this.props.showMessage({
                    message: "Something went wrong please try again",
                    type: false
                });
            })
    }

    render() {
            let usernameLabel = 'Email';
            let passwordLabel = 'Password';
            let cpasswordLabel = 'Confirm Password';
            if(config.domain == 'pt') {
                usernameLabel = 'Email';
                passwordLabel = 'Senha';
                cpasswordLabel = 'Confirmar Senha';
            }
            const { username, password, cpassword, submitted, loading, error } = this.state;
            return (
                submitted == false ?
                <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                        <Col>
                            <Row className="login-page-header">
                                <div className="login-page-header-child">
                                    <img className="login-page-logo" src="./img/logo.png" alt="Mobio360" width="125px" />
                                </div>
                            </Row>
                            <form name="form">
                            <Row className="login-page-content">
                                <h1>
                                    <FormattedMessage id="passWordregTag"
                                        defaultMessage="Register : Mobio360?"
                                    />
                                </h1>
                                <p>
                                    <FormattedMessage id="passRegthenConfirm"
                                        defaultMessage="Then confirm your email and get unlimited access to all our content"
                                    />
                                </p>

                                <div className="login-page-mobile_num">
                                    <input type="email" name="username" placeholder={usernameLabel} value={username} onChange={this.handleChange} className="LoginRoute-number" required/>
                                    {error.email && 
                                        <span className="error-message"><FormattedMessage id="email-required"
                                        defaultMessage="Email is required."
                                    /></span>
                                    }
                                    <input type="password" name="password" placeholder={passwordLabel} value={password} onChange={this.handleChange} className="LoginRoute-number" required/>
                                    {error.password &&
                                        <span className="error-message">
                                            <FormattedMessage id="password-required"
                                            defaultMessage="Password is required."
                                            />
                                        </span>
                                    }
                                    <input type="password" name="cpassword"  placeholder={cpasswordLabel}  value={cpassword} onChange={this.handleChange} className="LoginRoute-number" required/>
                                    {error.cpassword &&
                                        <span className="error-message">
                                         <FormattedMessage id="confirm-password-required"
                                         defaultMessage="Confirm password is required."
                                        />
                                     </span>
                                        }
                                    <button type="button"  disabled={loading} onClick={this.handleSubmit} className="LoginRoute-button">
                                        {loading ?<Loader/> :
                                        <FormattedMessage id="passwordRegisterButton"
                                            defaultMessage="Register"
                                        />}
                                    </button>
                                </div>
                            </Row>
                            </form>
                        </Col>
                                <Row className="login-page-content">
                                    <Link className="reg-link" to={`/loginWithEmailId/?uid=${getUid()}`}>
                                        <FormattedMessage id="passwordSignupOnReg"
                                            defaultMessage="Already have an account ?"
                                        />
                                    </Link>
                                </Row>
                    </Row>
                </div>
                : <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                     <Col>
                        <Row className="login-page-header">
                            <div className="login-page-header-child">
                                <img className="login-page-logo" src="./img/logo.png" alt="Mobio360" width="125px" />
                            </div>
                        </Row>
                        <Row className="login-page-content">
                            <h1>
                                <FormattedMessage id="regSucessHead"
                                    defaultMessage="Thank you for registration!"
                                />
                            </h1>
                            <Row className="login-page-content">
                                    <Link className="reg-link" to={`/loginWithEmailId/?uid=${getUid()}`}>
                                        <FormattedMessage id="clicki-to-login"
                                            defaultMessage="Click here to Login ?"
                                        />
                                    </Link>
                                </Row>
                        </Row>
                       </Col> 
                    </Row>
                    </div>
            );
        
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        checkAccess,
        show,
        hide,
        showMessage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);



// WEBPACK FOOTER //
// ./src/components/Register/RegisterForm.js